import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has been stable for `delayMs`. Each new `value`
 * resets the timer, so rapid changes never propagate — the latest value
 * wins after the user stops changing it.
 *
 * Used to debounce expensive query strings (e.g. Places autocomplete) so
 * fast typing doesn't fan out to a request per keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
